import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PlayCircle } from '@phosphor-icons/react';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { TUTORIALS } from '../pages/TutorialsPage';

export const WatchHowLink = ({ slug, label = 'Watch how', light = false, className = '' }) => {
  const [open, setOpen] = useState(false);
  const t = TUTORIALS.find(x => x.slug === slug);
  if (!t) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title={t.title}
        className={`inline-flex items-center gap-1 text-[10px] font-semibold whitespace-nowrap transition-colors ${
          light ? 'text-white/85 hover:text-white' : 'text-[#0B5394] hover:underline'
        } ${className}`}
        data-testid={`watch-how-${slug}`}
      >
        <PlayCircle size={13} weight="fill" />
        {label}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[760px] p-0 gap-0 overflow-hidden rounded-md" data-testid={`watch-how-dialog-${slug}`}>
          {open && (
            <video controls autoPlay poster={t.poster} className="w-full aspect-video bg-slate-900" data-testid={`watch-how-video-${slug}`}>
              <source src={t.src} type="video/mp4" />
            </video>
          )}
          <div className="px-5 py-4">
            <DialogTitle className="text-sm font-bold text-[#111827]">{t.title}</DialogTitle>
            <p className="text-xs text-slate-600 mt-1 leading-relaxed">{t.description}</p>
            <Link
              to="/tutorials"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-2 text-[11px] font-semibold text-[#0B5394] hover:underline"
              data-testid={`watch-how-all-${slug}`}
            >
              All video tutorials →
            </Link>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
